module["exports"] = [
  "Gruppen",
  "AB",
  "HB",
  "Group",
  "Investment",
  "Kommanditbolag",
  "Aktiebolag"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/sv/company/suffix.js
// module id = 969
// module chunks = 0